{
  "header": {
    "appName": "Bennie",
    "workspaces": "工作区",
    "projects": "项目",
    "analytics": "分析",
    "reggie": "测试场",
    "settings": "设置",
    "signOut": "退出登录",
    "home": "首页",
    "ariaLogo": "Kyronyx",
    "tooltipAccount": "账户",
    "userPlaceholder": "用户",
    "notSignedIn": "未登录",
    "signedIn": "已登录",
    "administrator": "管理员",
    "signIn": "登录",
    "profile": "个人资料",
    "models": "模型",
    "dashboard": "仪表板"
  },
  "rail": {
    "navLabel": "主导航",
    "modelLinksLabel": "模型分区",
    "trailLabel": "面包屑导航"
  },
  "breadcrumb": {
    "workspaces": "工作区",
    "workspace": "工作区",
    "plan": "计划",
    "report": "报告",
    "files": "文件"
  },
  "tabs": {
    "data": "数据",
    "plan": "计划",
    "report": "报告",
    "settings": "设置"
  },
  "userMenu": {
    "settings": "设置",
    "signOut": "退出登录"
  },
  "serviceSelection": {
    "comingSoonAppend": "{{description}} — 不可用",
    "continue": "继续",
    "selectServiceType": "选择服务类型",
    "genericTaskTitle": "通用任务",
    "genericTaskDescription": "跳过服务选择。直接上传文档并生成自定义报告。",
    "availabilityWarning": "无法验证服务可用性。已显示全部类别 — 部分可能尚未加载策划知识。",
    "serviceTypes": {
      "validation": "验证",
      "auditing": "审计",
      "development": "开发"
    }
  }
}
